import {message} from "ant-design-vue";
const exports = {}
exports.install =function (Vue,options) {

  Vue.prototype._copy_text = function (text){
    var textarea = document.createElement("input");//创建input对象
    var currentFocus = document.activeElement;//当前获得焦点的元素
    document.body.appendChild(textarea);//添加元素
    textarea.value = text;
    textarea.focus();
    if(textarea.setSelectionRange)
      textarea.setSelectionRange(0, textarea.value.length);//获取光标起始位置到结束位置
    else
      textarea.select();
    try {
      var flag = document.execCommand("copy");//执行复制
    } catch(eo) {
      var flag = false;
    }
    document.body.removeChild(textarea);//删除元素
    currentFocus.focus();
    message.success("复制成功")
    return flag;
  }

  Vue.prototype._export_cvs = function(data, columns, fileName) {
    const rows = data.map(t => {
      let obj = {}
      columns.forEach(col => {
        let val = t[col.dataIndex]
        obj[col.dataIndex] = val;
      })
      return obj
    })
    const fields = columns.map(t => { return {value:t.dataIndex,label:t.title}})
    try {
      const result = json2csv.parse(rows, { fields: fields,excelStrings:true});
      const csvContent = 'data:text/csv;charset=utf-8,\uFEFF' + result
      const link = document.createElement('a')
      link.href = encodeURI(csvContent)
      link.download = `${fileName}.csv`
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    } catch (err) {
      alert(err)
    }
  }

  Vue.prototype._get_current_date = function (format) {
    var now = new Date();
    var year = now.getFullYear(); //得到年份
    var month = now.getMonth(); //得到月份
    var date = now.getDate(); //得到日期
    var day = now.getDay(); //得到周几
    var hour = now.getHours(); //得到小时
    var minu = now.getMinutes(); //得到分钟
    var sec = now.getSeconds(); //得到秒
    month = month + 1;
    if (month < 10) month = "0" + month;
    if (date < 10) date = "0" + date;
    if (hour < 10) hour = "0" + hour;
    if (minu < 10) minu = "0" + minu;
    if (sec < 10) sec = "0" + sec;
    var time = "";
    //精确到天
    if (format == 1) {
      time = year + "年" + month + "月" + date + "日";
    }
    //精确到分
    else if (format == 2) {
      time = year + "-" + month + "-" + date + " " + hour + ":" + minu + ":" + sec;
    }
    else if (format == 3) {
      time = year + "-" + month + "-" + date ;
    }
    return time;
  }

  Vue.prototype._get_table_scroll = function({ extraHeight, id }) {
    if (typeof extraHeight == "undefined") {
      //  默认底部分页64 + 边距10
      // extraHeight = 74
      extraHeight = 10
    }
    let tHeader = null
    if (id) {
      tHeader = document.getElementById(id) ?
        document.getElementById(id).getElementsByClassName("ant-table-thead")[0] : null
    } else {
      tHeader = document.getElementsByClassName("ant-table-thead")[0]
    }
    //表格内容距离顶部的距离
    let tHeaderBottom = 0
    if (tHeader) {
      tHeaderBottom = tHeader.getBoundingClientRect().bottom
    }
    //窗体高度-表格内容顶部的高度-表格内容底部的高度
    // let height = document.body.clientHeight - tHeaderBottom - extraHeight
    let height = `calc(100vh - ${tHeaderBottom + extraHeight}px)`
    return height
  }
}
export default exports



// WEBPACK FOOTER //
// ./src/utils/actions.js